<div class="card bg-dark text-white">
    <img class="card-img" src="../assets/img/modulo.png" alt="Card image">
    <div class="card-img-overlay" [innerHtml]="descricao">
      
    </div>
  </div>
